var render, staticRenderFns
import script from "./ImageSlider.vue?vue&type=script&lang=js&"
export * from "./ImageSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f4e8db8')) {
      api.createRecord('7f4e8db8', component.options)
    } else {
      api.reload('7f4e8db8', component.options)
    }
    
  }
}
component.options.__file = "tmp/tmp-2yKOn6QKw6xUf/JS/comp/ImageSlider.vue"
export default component.exports